// 初始化地图
export default {
  init() {
    return new Promise((resolve, reject) => {
      // 如果已加载直接返回
      if (window.T) {
        resolve(window.T)
        reject(new Error('error'))
      }
    })
  }
}
